import { render } from "./CommentOneliner.vue?vue&type=template&id=c3513184"
import script from "./CommentOneliner.vue?vue&type=script&lang=js"
export * from "./CommentOneliner.vue?vue&type=script&lang=js"

import "./CommentOneliner.vue?vue&type=style&index=0&id=c3513184&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__